import React from "react";
import { FiZap, FiTv, FiPlayCircle, FiSmartphone } from "react-icons/fi";
import { LuSettings, LuSearch, LuPalette, LuCircleCheck, LuUsers, LuShield, LuPercent, LuSmartphone, LuShieldCheck, LuCode, LuRocket, LuClipboardList } from "react-icons/lu";

export const OttHeroData = {
  backgroundImage: "/images/serviceBanners/MyOutdoorTV.webp",
  whiteImage: "/images/serviceBanners/outdoorWhite.webp",
  subTitle: "OTT Platform Development Services",
  title: (
    <>
      Next-Gen <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">OTT Platform Development</span>
    </>
  ),
  description:
    "We build scalable, high performance OTT platforms with advanced streaming architecture to deliver smooth video playback, multi device compatibility, and seamless user experience across digital entertainment ecosystems.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("OTT Quote clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("OTT Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Fast and optimized OTT streaming performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Smooth viewing experience across all devices and screen sizes.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Strong security for content protection and stable streaming.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Maintainable and scalable OTT platform architecture.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/icons/aws_icon.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(255,153,0,0.35)",
      iconGlow: "rgba(255,153,0,0.9)",
    },
  ],
};

// 2. Stats Block
export const ottStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const ottSolutionsAndProcessData = {
  buildSubtitle: "OUR OTT SERVICES",
  buildTitle: "Custom OTT Platform Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform OTT Support",
      desc: "Build scalable OTT apps for Android, iOS, and web with smooth streaming experience.",
      icon: FiTv,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Enterprise OTT Solutions",
      desc: "Develop secure and high-traffic streaming platforms for large media businesses.",
      icon: FiPlayCircle,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Content Streaming Apps",
      desc: "Create feature-rich video platforms with seamless playback and user engagement.",
      icon: FiSmartphone,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand OTT Apps",
      desc: "Build real-time streaming apps for movies, shows, and live content delivery.",
      icon: FiZap,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Secure OTT Systems",
      desc: "Develop protected platforms with DRM and secure content delivery mechanisms.",
      icon: FiPlayCircle,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Custom OTT Development",
      desc: "Create tailored streaming solutions based on specific business and audience needs.",
      icon: FiTv,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OTT PLATFORM DEVELOPMENT PROCESS",
  processTitle: "OTT Platform Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Consultation",
      description: "Understand OTT business goals, audience needs, and streaming requirements.",
      icon: LuSearch,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define platform features, tech stack, and scalable architecture roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create intuitive and engaging streaming interface designs.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Development",
      description: "Build high-performance OTT platforms with scalable backend and playback systems.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "Test video streaming, performance, and cross-device compatibility validations.",
      icon: LuCircleCheck, // Correct Lucide icon to prevent framework build failure
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Launch OTT platform and ensure continuous maintenance and updates.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR OTT PLATFORM DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose OTT Platform Development Solutions",
  benefits: [
    "Cross-platform support",
    "Faster development cycle",
    "Modern UI design",
    "Smooth streaming performance",
    "Efficient workflow system",
    "Scalable OTT architecture",
    "Cost-effective development",
  ],
  logoImage: "/images/serviceBanners/MyOutdoorTV.webp",
  whiteLogoImage: "/images/serviceBanners/ottW.webp",
};

// 4. Portfolio Data
export const ottPortfolioData = {
  subtitle: "OUR CASE STUDIES",
  title: "Platforms Powering Entertainment",
  buttonText: "View Full Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "StreamMax Pro",
      badge: "Global VOD",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "An international streaming service with localized content handling 1M+ concurrent users.",
      downloads: "Active",
      rating: "5.0",
      image: "/images/MobileAppDevelopment/OTT-Streaming.png",
    },
  ],
};

// 5. Technologies Data
export const ottTechnologiesData = {
  techTitle: "STREAMING TOOL STACK",
  technologies: [
    { name: "AWS Media", icon: "RestAPI" },
    { name: "React Native", icon: "ReactJS" },
    { name: "ExoPlayer", icon: "Vite" },
    { name: "Node.js", icon: "Firebase" },
    { name: "Bitmovin", icon: "Code" },
    { name: "Swift/Kotlin", icon: "Dart" },
  ],
  trustTitle: "TRUSTED BY BROADCASTERS Worldwide",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

export const ottPlatformFaqs = [
  {
    q: "Which platforms do you support for OTT development?",
    a: "We develop for a wide range of platforms including iOS, Android, web, Apple TV, Android TV, Roku, Amazon Fire TV, and major Smart TVs.",
  },
  {
    q: "Can you help with video hosting and CDN?",
    a: "Yes, we partner with leading cloud providers to set up scalable video hosting, encoding pipelines, and content delivery networks.",
  },
  {
    q: "Do you implement DRM (Digital Rights Management)?",
    a: "Absolutely. We integrate industry-standard DRM solutions like Widevine, FairPlay, and PlayReady to protect your content.",
  },
];

export const ottAboutData = [
  {
    title: "OTT App Development Company for Scalable Streaming Platforms",
    content: (
      <>
        Modern audiences expect seamless access to entertainment and video content across multiple devices without interruptions. A trusted{" "}
        <b className="text-text-primary font-semibold">ott app development company</b> helps businesses create scalable streaming ecosystems designed for better engagement and
        long-term audience retention. Many businesses struggle with content delivery systems that fail to provide smooth viewing experiences as user demand grows. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, OTT platforms are developed around business objectives, content accessibility, and user expectations
        to help brands create dependable digital streaming experiences.
      </>
    ),
  },
  {
    title: "OTT Platform Development Services for Better Viewer Engagement",
    content: (
      <>
        Building a successful streaming platform requires more than simply hosting video content. Reliable{" "}
        <b className="text-text-primary font-semibold">ott platform development services</b> help businesses create structured systems that improve content organization, viewer
        retention, and platform usability. Companies investing in <b className="text-text-primary font-semibold">video streaming app development</b> often improve audience
        engagement because platforms become easier to navigate and more reliable across devices. Tycho Technologies focuses on practical streaming solutions designed to improve
        digital performance while supporting long-term scalability and user satisfaction.
      </>
    ),
  },
  {
    title: "Custom OTT Solutions for Smarter Content Delivery",
    content: (
      <>
        Businesses entering the digital entertainment space often require flexible platforms tailored around unique audience behavior and content goals. Effective{" "}
        <b className="text-text-primary font-semibold">custom ott solutions</b> help organizations improve accessibility, manage growing content libraries, and support better user
        experiences. Companies looking to strengthen digital ecosystems frequently combine media technologies with{" "}
        <a href="https://tychotechnologies.com/ionic-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          ionic app development company
        </a>{" "}
        solutions to create connected applications and improve cross-platform accessibility.
      </>
    ),
  },
  {
    title: "Why Businesses Choose an OTT Platform Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">ott platform development company in india</b> continues to grow as businesses seek scalable digital
        streaming ecosystems. Companies investing in <b className="text-text-primary font-semibold">ott app development services india</b> often prioritize platform reliability,
        audience engagement, and long-term business growth. Businesses partnering with Tycho Technologies gain access to customized OTT frameworks designed around measurable
        business objectives and user behavior. Many organizations also improve digital accessibility through{" "}
        <a href="https://tychotechnologies.com/ipad-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          ipad app development company
        </a>{" "}
        solutions to strengthen content experiences across tablet ecosystems.
      </>
    ),
  },
];
